import _get from 'lodash/get'
import _split from 'lodash/split'
import _reduce from 'lodash/reduce'
import _trim from 'lodash/trim'
import {
  get,
  set,
  expire,
} from 'cookies-js'
import { canSetCookie } from '../local-preferences/index'
import { get as getConfig } from '../../config/index'
import { isProduction } from '../../environment/index'
import { isBrowser } from '../../config/environment'

const config = getConfig()
const dataPrivacyCompliance = _get(config, ['features', 'anonymousUser', 'dataPrivacyCompliance'])
const oneTrustEnabled = !!_get(config, ['features', 'oneTrust'])

function getCookieDomain () {
  return !process.env.NODE_ENV || !isProduction()
    ? 'localhost'
    : '.gaia.com'
}

export function setCookie (name, value, path = '/', expires = 86400, secure = false, uid, authToken) {
  // if One Trust is enabled, then allow cookies to be set.
  // all of the places that set cookies needs to be responsible for making sure it is ok to do so
  if (oneTrustEnabled) {
    return set(name, value, {
      expires, // time in seconds
      domain: getCookieDomain(),
      path,
      secure,
    })
  }

  /* eslint-disable consistent-return */
  if (!canSetCookie(uid, authToken) && dataPrivacyCompliance && !oneTrustEnabled) {
    return
  }

  return set(name, value, {
    expires, // time in seconds
    domain: getCookieDomain(),
    path,
    secure,
  })
  /* eslint-enable consistent-return */
}

export function getCookie (name) {
  if (name) {
    return get(name)
  }
  return get()
}

export function expireCookie (name) {
  return expire(name, { domain: getCookieDomain() })
}

/**
 * Safely decode a cookie value. decodeURIComponent throws URIError for
 * malformed percent-encoding (e.g. from extensions or mobile WebViews).
 * Returns the raw value if decoding fails.
 */
function safeDecodeCookieValue (value) {
  try {
    return decodeURIComponent(value)
  } catch (_) {
    return value
  }
}

export function getAllCookies () {
  if (!isBrowser()) {
    return {}
  }

  return _reduce(
    _split(document?.cookie || '', ';'),
    (cookies, cookieStr) => {
      const [name, ...rest] = _split(cookieStr, '=')
      const trimmedName = _trim(name)
      if (!trimmedName) {
        return cookies
      }
      const rawValue = rest.join('=')
      return {
        ...cookies,
        [trimmedName]: safeDecodeCookieValue(rawValue),
      }
    },
    {},
  )
}
